import { render, staticRenderFns } from "./BusinessSchoolPopup.vue?vue&type=template&id=0cd2b5ab&scoped=true"
import script from "./BusinessSchoolPopup.vue?vue&type=script&lang=js"
export * from "./BusinessSchoolPopup.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./BusinessSchoolPopup.vue?vue&type=style&index=1&id=0cd2b5ab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd2b5ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd2b5ab')) {
      api.createRecord('0cd2b5ab', component.options)
    } else {
      api.reload('0cd2b5ab', component.options)
    }
    module.hot.accept("./BusinessSchoolPopup.vue?vue&type=template&id=0cd2b5ab&scoped=true", function () {
      api.rerender('0cd2b5ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/BusinessSchool/components/BusinessSchoolPopup.vue"
export default component.exports